import React from 'react';

const Logo = props => (
    <b>EasyEx Warehouse System</b>
);

export default Logo;